// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__exj7V","content":"Modal_content__3TwHP","active":"Modal_active__3x1ac","videoMod":"Modal_videoMod__1ts0M"};